import { getToken } from './auth';

const config = window.pcaSettings;

async function request(path, method = 'GET', body) {
  const token = await getToken();
  if (!token) throw new Error('Not authenticated');
  const opts = {
    method,
    headers: { Authorization: `Bearer ${token}` },
    mode: 'cors'
  };
  if (body) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(`${config.api.uri}${path}`, opts);
  let data;
  try {
    data = await res.json();
  } catch (e) {
    data = undefined;
  }
  if (!res.ok) {
    const msg = (data && data.error) || res.statusText || 'Request failed';
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

// One page of agents: { agents, next, matched, counts, generalManagers }.
// params: count, q, email (all/with/without), sort (name/email/updatedAt),
// dir (asc/desc) and after (the previous page's `next`).
export function listAgentsWithEmails(params = {}) {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  ).toString();
  return request(`/agents/emails${query ? `?${query}` : ''}`);
}

// `loginUsername`: a Call Agent login to link to this agent, '' to unlink, or undefined to leave as is.
export function updateAgentEmail(agentName, email, role, gmUsername, actorEmail, loginUsername) {
  return request(`/agents/${encodeURIComponent(agentName)}/email`, 'PUT', { email, role, gmUsername, actorEmail, loginUsername });
}

// The signed-in user's own agent role and, for a General Manager, the agents on their team:
// { username, agentName, role, members: [name, ...] }. `agentName` is the name the user's own calls
// are filed under (their linked agent, or their username). Names are the way /list expects `username`.
export function getMyTeam() {
  return request('/agents/team');
}

// A General Manager adds `agentName` to their own team (join true) or takes them off it (join false).
export function setTeamMember(agentName, join) {
  return request(`/agents/${encodeURIComponent(agentName)}/team`, 'PUT', { join });
}

export function listActivityActors() {
  return request('/agents/activity');
}

export function getActorActivity(actor) {
  return request(`/agents/activity/${encodeURIComponent(actor)}`);
}
